(function gridScrollMemory() {
  if ('scrollRestoration' in history) { try { history.scrollRestoration = 'manual'; } catch (e) {} }
  function key() { return 'sply-gs:' + location.pathname + location.search; }
  function isGrid() { return !!document.querySelector('[data-sply-surface]'); }
  function save() { if (isGrid()) { try { sessionStorage.setItem(key(), String(window.scrollY || window.pageYOffset || 0)); } catch (e) {} } }
  function restore() {
    if (!isGrid()) return;
    try {
      var y = sessionStorage.getItem(key());
      if (y == null) return;
      var n = parseInt(y, 10) || 0;
      window.scrollTo(0, n);
      window.requestAnimationFrame(function () { window.scrollTo(0, n); });
    } catch (e) {}
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.sply-card__link')) save(); }, true);
  window.addEventListener('pagehide', save);
  if ('onpagereveal' in window) window.addEventListener('pagereveal', restore);
  window.addEventListener('pageshow', restore);
  restore();
})();

(function bfcacheBackReveal() {
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;                                   // only bfcache restores (desktop history.back)
    if (!document.querySelector('[data-sply-surface]')) return; // only when landing back on the grid
    var back; try { back = sessionStorage.getItem('sply-navback'); } catch (er) {}
    if (!back) return;
    try { sessionStorage.removeItem('sply-navback'); } catch (er) {}
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var h; try { h = sessionStorage.getItem('sply-vt-from'); } catch (er) {}
    var a = h && document.querySelector('.sply-card__link[data-sply-handle="' + h + '"]');
    var media = a && a.querySelector('.sply-card__media');
    if (!media) return;
    media.style.opacity = '0';                                  // blank the spot before paint (no flash)
    window.requestAnimationFrame(function () {
      media.style.opacity = '';
      media.animate([
        { opacity: 0, transform: 'scale(1.06)' },
        { opacity: 1, transform: 'none' }
      ], { duration: 460, easing: 'cubic-bezier(.22,1,.36,1)' });
    });
  });
})();

(function initViewTransitions() {
  if (!('onpageswap' in window) || !('onpagereveal' in window)) return;
  var HERO = 'sply-hero';
  function handleFromUrl(url) {
    try { var m = new URL(url, location.href).pathname.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
    catch (e) { return null; }
  }
  function gridImg(h) {
    if (!h) return null;
    var a = document.querySelector('.sply-card__link[data-sply-handle="' + h + '"]');
    return a ? a.querySelector('img') : null;
  }
  function clearHero() {
    var els = document.querySelectorAll('.sply-card__link img[style]');
    for (var i = 0; i < els.length; i++) { els[i].style.viewTransitionName = ''; }
  }
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    var to = e.activation && e.activation.entry && e.activation.entry.url;
    var img = gridImg(handleFromUrl(to));
    if (img) img.style.viewTransitionName = HERO;
    var seq = document.querySelector('[data-sply-seq]');
    if (seq) { try { sessionStorage.setItem('sply-vt-from', (JSON.parse(seq.textContent) || {}).current || ''); } catch (er) {} }
  });
  window.addEventListener('pagereveal', function (e) {
    if (!e.viewTransition) return;
    if (document.querySelector('[data-sply-surface]')) {
      var img = gridImg(sessionStorage.getItem('sply-vt-from'));
      if (img) img.style.viewTransitionName = HERO;
      e.viewTransition.finished.then(clearHero);
    }
  });
})();

(function () {
  var zoomIn = document.querySelector('.sply-zoom-in');
  var zoomOut = document.querySelector('.sply-zoom-out');
  var surface = document.querySelector('[data-sply-surface]');
  var pdp = document.querySelector('[data-sply-pdp]');
  var swapping = false;
  var vtFinish = null;
  var sectionCache = {};
  var reduceMo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // "decode" / terminal scramble for the product title on product-to-product swaps
  function scrambleTitle(el) {
    if (!el) return;
    var finalText = (el.textContent || '').trim();
    if (!finalText) return;
    if (el._splyIv) { window.clearInterval(el._splyIv); el._splyIv = null; }
    if (reduceMo) { el.textContent = finalText; return; }
    var glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var q = [];
    for (var i = 0; i < finalText.length; i++) {
      var c = finalText.charAt(i);
      var fixed = (c === ' ' || c === '-' || c === '/' || c === '.');
      q.push({ c: c, fixed: fixed, end: fixed ? 0 : Math.round(i * 1.7) + 5 + Math.floor(Math.random() * 6) });
    }
    var frame = 0;
    el._splyIv = window.setInterval(function () {
      var out = '', done = 0;
      for (var j = 0; j < q.length; j++) {
        var it = q[j];
        if (it.fixed || frame >= it.end) { out += it.c; done++; }
        else { out += glyphs.charAt(Math.floor(Math.random() * glyphs.length)); }
      }
      el.textContent = out;
      frame++;
      if (done === q.length) { window.clearInterval(el._splyIv); el._splyIv = null; el.textContent = finalText; }
    }, 32);
  }
  function sectionEndpoint(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var sid = (pdp && pdp.getAttribute('data-sply-section-id')) || 'main';
    return url + sep + 'section_id=' + encodeURIComponent(sid);
  }

  if (surface) {
    initZoom(surface);
    staggerReveal(surface);
    initCatbar(surface);
  } else if (pdp) {
    if (zoomIn) zoomIn.hidden = true;
    if (zoomOut) {
      zoomOut.hidden = false;
      zoomOut.addEventListener('click', function () {
        try {
          sessionStorage.setItem('sply-navback', '1');
          var ph = location.pathname.match(/\/products\/([^/?#]+)/);
          if (ph) sessionStorage.setItem('sply-vt-from', ph[1]);
        } catch (e) {}
        // go back to wherever they came from (home or collection), not a fixed collection
        var ref = document.referrer;
        if (window.history.length > 1 && ref && ref.indexOf(window.location.origin) === 0) {
          window.history.back();
          return;
        }
        window.location.href = '/';
      });
    }
  } else {
    // static pages (policy, page, blog, search, 404, etc.): chevron always goes home to the products,
    // not back through other static pages
    if (zoomIn) zoomIn.hidden = true;
    if (zoomOut) {
      zoomOut.hidden = false;
      zoomOut.addEventListener('click', function () { try { sessionStorage.setItem('sply-restagger', '1'); } catch (e) {} window.location.href = '/'; });
    }
  }

  // global keyboard -> current image carousel
  var carouselApi = null;
  var magHide = function () {};
  var magRefresh = function () {};
  document.addEventListener('keydown', function (e) {
    if (!carouselApi) return;
    if (e.key === 'ArrowLeft') carouselApi.go(carouselApi.index() - 1);
    else if (e.key === 'ArrowRight') carouselApi.go(carouselApi.index() + 1);
  });

  if (pdp) {
    document.documentElement.classList.add('sply--pdp');
    initCarousel(pdp);
    initWheelNav(pdp);
    prefetchNeighbors();
    setupMagnifier();
  }

  /* ---------- grid zoom (per-item FLIP) ---------- */
  /* ---------- category filter bar: in-place FLIP reshuffle ---------- */
  function initCatbar(surface) {
    var bar = document.querySelector('[data-sply-catbar]');
    if (!bar) return;                                   // collection-link mode has no data-sply-catbar (plain nav)
    var grid = surface.querySelector('[data-sply-grid]');
    if (!grid) return;
    var source = bar.getAttribute('data-source') || 'type';
    var chips = Array.prototype.slice.call(bar.querySelectorAll('.sply-catbar__chip'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('.sply-card')); }
    function match(c, cat) {
      if (cat === 'all') return true;
      if (source === 'tag') { return ((c.getAttribute('data-tags') || '').split(',').indexOf(cat) >= 0); }
      return (c.getAttribute('data-type') || '') === cat;
    }
    function apply(cat) {
      var all = cards(), leaving = [], staying = [], entering = [];
      all.forEach(function (c) {
        var m = match(c, cat), vis = !c.hidden;
        if (m && vis) staying.push(c); else if (m && !vis) entering.push(c); else if (!m && vis) leaving.push(c);
      });
      if (reduce) { all.forEach(function (c) { c.hidden = !match(c, cat); }); return; }
      leaving.forEach(function (c) { c.style.transition = 'opacity .22s ease, transform .22s ease'; c.style.opacity = '0'; c.style.transform = 'scale(.95)'; });
      var go = function () {
        var first = staying.map(function (c) { return c.getBoundingClientRect(); });   // FIRST (leavers still in flow)
        leaving.forEach(function (c) { c.style.cssText = ''; c.hidden = true; });        // remove from flow
        entering.forEach(function (c) { c.hidden = false; });
        var last = staying.map(function (c) { return c.getBoundingClientRect(); });     // LAST (reflowed)
        staying.forEach(function (c, i) {                                                // INVERT
          var dx = first[i].left - last[i].left, dy = first[i].top - last[i].top;
          c.style.transition = 'none'; c.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        });
        entering.forEach(function (c) { c.style.transition = 'none'; c.style.opacity = '0'; c.style.transform = 'scale(.96)'; });
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () {  // PLAY
          staying.forEach(function (c) { c.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1)'; c.style.transform = 'translate(0,0)'; });
          entering.forEach(function (c, i) { var d = (i * 40); c.style.transition = 'opacity .4s ease ' + d + 'ms, transform .5s cubic-bezier(.22,1,.36,1) ' + d + 'ms'; c.style.opacity = '1'; c.style.transform = 'scale(1)'; });
        }); });
        window.setTimeout(function () { staying.concat(entering).forEach(function (c) { c.style.transition = ''; c.style.transform = ''; c.style.opacity = ''; }); }, 780);
      };
      if (leaving.length) window.setTimeout(go, 230); else go();
    }
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('.sply-catbar__chip');
      if (!chip || chip.tagName === 'A') return;
      e.preventDefault();
      if (chip.classList.contains('is-active')) return;
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      apply(chip.getAttribute('data-cat'));
    });
  }

  function staggerReveal(surface) {
    var root = document.documentElement;
    if (!root.classList.contains('sply-prestagger')) return;          // gated first landing OR restagger on return
    try { sessionStorage.removeItem('sply-restagger'); } catch (e) {}  // consume the return-to-home flag
    if (window.__splyLoaderActive) {                                   // sequence: hold the domino until the loading screen dissolves
      document.addEventListener('sply:loaderdone', function () { runStagger(surface); }, { once: true });
      return;
    }
    runStagger(surface);
  }
  function runStagger(surface) {
    var root = document.documentElement;
    var grid = surface.querySelector('[data-sply-grid]');
    if (!grid || surface.getAttribute('data-sply-zoom') !== '0') { root.classList.remove('sply-prestagger'); return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.sply-card'));
    if (cards.length < 2) { root.classList.remove('sply-prestagger'); return; }
    try { sessionStorage.setItem('sply-landed', '1'); } catch (e) {}   // once per session
    cards.forEach(function (c, i) { c.style.transitionDelay = (i * 28) + 'ms'; });   // domino, row by row
    grid.getBoundingClientRect();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        cards.forEach(function (c) { c.classList.add('is-in'); });
      });
    });
    window.setTimeout(function () {                                    // cleanup so it never affects the zoom transition
      cards.forEach(function (c) { c.style.transitionDelay = ''; c.classList.remove('is-in'); });
      root.classList.remove('sply-prestagger');
    }, cards.length * 28 + 750);
  }

  function initZoom(surface) {
    var MAX_ZOOM = 1;
    var zoom = 0;
    var grid = surface.querySelector('[data-sply-grid]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'transform .5s cubic-bezier(0.22,1,0.36,1)';
    function sync() {
      if (zoomIn) zoomIn.hidden = zoom >= MAX_ZOOM;
      if (zoomOut) zoomOut.hidden = zoom <= 0;
    }
    function setZoom(n) {
      n = Math.max(0, Math.min(MAX_ZOOM, n));
      if (n === zoom || !grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.sply-card'));
      var firsts = cards.map(function (c) { return c.getBoundingClientRect(); });
      zoom = n; sync();
      surface.setAttribute('data-sply-zoom', String(zoom));
      navMorphTo(zoom > 0 ? 'chevron' : 'plus', 360);
      if (reduce || !cards.length) return;
      cards.forEach(function (c, idx) {
        var first = firsts[idx];
        var last = c.getBoundingClientRect();
        var dx = first.left - last.left;
        var dy = first.top - last.top;
        var sc = last.width ? (first.width / last.width) : 1;
        c.style.transformOrigin = 'top left';
        c.style.transition = 'none';
        c.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')';
        c.style.willChange = 'transform';
      });
      grid.getBoundingClientRect();
      window.requestAnimationFrame(function () {
        cards.forEach(function (c) { c.style.transition = EASE; c.style.transform = ''; });
      });
    }
    if (grid) {
      grid.addEventListener('transitionend', function (e) {
        var c = e.target;
        if (e.propertyName === 'transform' && c.classList && c.classList.contains('sply-card')) {
          c.style.transition = ''; c.style.transform = ''; c.style.transformOrigin = ''; c.style.willChange = '';
        }
      });
    }
    if (zoomIn) zoomIn.addEventListener('click', function () { setZoom(zoom + 1); });
    if (zoomOut) zoomOut.addEventListener('click', function () { setZoom(zoom - 1); });
    surface.setAttribute('data-sply-zoom', '0');
    sync();
  }

  /* ---------- product sequence (vertical swipe) ---------- */
  function readSeq() {
    var node = pdp && pdp.querySelector('[data-sply-seq]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function seqIndex(data) {
    var p = data.products, cur = -1;
    for (var k = 0; k < p.length; k++) { if (p[k].handle === data.current) { cur = k; break; } }
    return cur;
  }
  function preloadImage(src) { if (!src) return; var im = new Image(); im.decoding = 'async'; im.src = src; }
  function firstImgSrc(html) { var m = html && html.match(/<img[^>]+src="([^"]+)"/i); return m ? m[1] : null; }
  function prefetchSection(url) {
    if (!url || !sectionCache || sectionCache[url]) return;
    sectionCache[url] = 'pending';
    fetch(sectionEndpoint(url))
      .then(function (r) { return r.text(); })
      .then(function (h) { sectionCache[url] = h; preloadImage(firstImgSrc(h)); })
      .catch(function () { delete sectionCache[url]; });
  }
  function prefetchNeighbors() {
    var data = readSeq();
    if (!data || !data.products || data.products.length < 2) return;
    var p = data.products, cur = seqIndex(data);
    if (cur < 0) return;
    var nxt = p[(cur + 1) % p.length], prv = p[(cur - 1 + p.length) % p.length];
    preloadImage(nxt.img); preloadImage(prv.img);   // preload neighbor images now, straight from seq data (no section fetch to wait on)
    prefetchSection(nxt.url);
    prefetchSection(prv.url);
  }

  function navigateProduct(dir) {
    if (swapping) return;
    var data = readSeq();
    if (!data || !data.products || data.products.length < 2) return;
    var cur = seqIndex(data), p = data.products;
    if (cur < 0) return;
    var target = p[((cur + dir) % p.length + p.length) % p.length];
    swapProduct(target.url, dir);
  }

  function applySection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-sply-pdp]');
    if (!fresh) return false;
    pdp.innerHTML = fresh.innerHTML;
    pdp.setAttribute('data-transition', fresh.getAttribute('data-transition') || 'slide');
    pdp.setAttribute('data-arrows-mobile', fresh.getAttribute('data-arrows-mobile') || 'true');
    return true;
  }

  function swapProduct(url, dir) {
    if (swapping) return;
    swapping = true;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var safety = window.setTimeout(function () { swapping = false; }, 2600);

    function commit(fresh) {
      pdp.innerHTML = fresh.innerHTML;
      pdp.setAttribute('data-transition', fresh.getAttribute('data-transition') || 'slide');
      pdp.setAttribute('data-arrows-mobile', fresh.getAttribute('data-arrows-mobile') || 'true');
      // the section's state lives on the pdp element itself (not its innerHTML) -> reset it per product,
      // otherwise stale is-buying/is-info or a mismatched simple/variant type glitches the next product (missing X, etc.)
      pdp.classList.remove('is-buying', 'is-info', 'is-loading', 'is-collapsing');
      pdp.classList.toggle('sply-pdp--simple', fresh.classList.contains('sply-pdp--simple'));
      pdp.style.transition = ''; pdp.style.transform = ''; pdp.style.opacity = ''; pdp.style.visibility = '';
      history.replaceState({}, '', url);
      try { var vh = url.match(/\/products\/([^/?#]+)/); if (vh) sessionStorage.setItem('sply-vt-from', vh[1]); } catch (e) {}   // keep the hero-return target on the product you swiped to
      initCarousel(pdp);
      scrambleTitle(pdp.querySelector('[data-sply-name]'));
      document.dispatchEvent(new Event('sply:reserve'));   // re-cap the new product's description
      swapping = false;
      prefetchNeighbors();
      window.setTimeout(magRefresh, 60);
    }
    function reveal(html) {
      window.clearTimeout(safety);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-sply-pdp]');
      if (!fresh) { window.location.href = url; return; }
      if (reduceMo) { commit(fresh); return; }
      runVCarousel(fresh, dir, function () { commit(fresh); });
    }

    var cached = sectionCache[url];
    if (cached && cached !== 'pending') { reveal(cached); return; }
    fetch(sectionEndpoint(url))
      .then(function (r) { return r.text(); })
      .then(reveal)
      .catch(function () { window.clearTimeout(safety); window.location.href = url; });
  }

  /* vertical product carousel: image box slides, next image stacked tight behind it.
     Panels are absolutely positioned so the track starts at an untransformed state, then a
     CSS class drives the transition (reliable; matches the image carousel mechanism). */
  function runVCarousel(fresh, dir, done) {
    magHide();
    var vp = pdp.querySelector('[data-pdp-viewport]');
    var freshImg = fresh.querySelector('.sply-pdp__slide img');
    if (!vp || !freshImg) { done(); return; }
    var V = vp.getBoundingClientRect();
    if (!V.height) { done(); return; }

    var imgs = vp.querySelectorAll('.sply-pdp__slide img');
    var idx = 0;
    var trackEl = vp.querySelector('[data-pdp-track]');
    if (trackEl) { var m = (trackEl.style.transform || '').match(/-?(\d+(?:\.\d+)?)%/); if (m) idx = Math.round(parseFloat(m[1]) / 100); }
    var curImg = imgs[idx] || imgs[0];
    var curSrc = curImg ? (curImg.currentSrc || curImg.src) : '';
    var inSrc = freshImg.getAttribute('src');

    var overlay = document.createElement('div');
    overlay.className = 'sply-vt';
    overlay.style.top = V.top + 'px';
    overlay.style.left = V.left + 'px';
    overlay.style.width = V.width + 'px';
    overlay.style.height = V.height + 'px';

    var track = document.createElement('div');
    track.className = 'sply-vt__track';

    function panel(src, top) {
      var pnl = document.createElement('div');
      pnl.className = 'sply-vt__slide';
      pnl.style.top = top + 'px';
      var im = document.createElement('img');
      im.className = 'sply-vt__img'; im.alt = ''; im.src = src;
      pnl.appendChild(im);
      return pnl;
    }
    track.appendChild(panel(curSrc, 0));
    track.appendChild(panel(inSrc, dir > 0 ? V.height : -V.height));
    overlay.appendChild(track);
    document.body.appendChild(overlay);
    vp.style.visibility = 'hidden';
    track.getBoundingClientRect();
    track.classList.add('is-anim');

    var finished = false;
    function finish() { if (finished) return; finished = true; vtFinish = null; if (overlay.parentNode) overlay.parentNode.removeChild(overlay); done(); }
    vtFinish = finish;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        track.style.transform = 'translateY(' + (dir > 0 ? -V.height : V.height) + 'px)';
      });
    });
    track.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') finish(); });
    window.setTimeout(finish, 760);
  }

  /* ---------- product view: wheel / trackpad -> product nav ---------- */
  function initWheelNav(pdpEl) {
    // One physical swipe == one move, but stay browseable: after firing we lock against the
    // gesture's own momentum tail, yet a fresh flick (a rise in delta after it was decaying)
    // unlocks immediately so you can keep flicking through products without waiting.
    var ax = 0, ay = 0, locked = false, raf = null, idle = null, lastMag = 0, imgBusy = false, imgBusyT = null;
    function release() { locked = false; ax = 0; ay = 0; lastMag = 0; }
    pdpEl.addEventListener('wheel', function (e) {
      var dsc = e.target && e.target.closest ? e.target.closest('.sply-pdp__desc') : null;
      if (dsc && dsc.scrollHeight > dsc.clientHeight) {
        var atTop = dsc.scrollTop <= 0;
        var atBottom = dsc.scrollTop + dsc.clientHeight >= dsc.scrollHeight - 1;
        if ((e.deltaY < 0 && !atTop) || (e.deltaY > 0 && !atBottom)) return;  // let the description scroll
      }
      e.preventDefault();
      var mag = Math.max(Math.abs(e.deltaX), Math.abs(e.deltaY));
      window.clearTimeout(idle);
      idle = window.setTimeout(release, 120);
      // a move is "busy" while its animation plays so the same flick's momentum can't skip ahead:
      // vertical uses `swapping` (product slide); horizontal uses imgBusy (image slide).
      if (swapping || imgBusy) { lastMag = mag; return; }
      if (locked) {
        if (mag > lastMag * 1.25 + 10) { locked = false; ax = 0; ay = 0; } // new flick
        else { lastMag = mag; return; }                                    // momentum tail
      }
      lastMag = mag;
      ax += e.deltaX; ay += e.deltaY;
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var horizontal = Math.abs(ax) > Math.abs(ay);
        if (horizontal && Math.abs(ax) >= 50) {
          locked = true; var dx = ax > 0 ? 1 : -1; ax = 0; ay = 0;
          imgBusy = true; window.clearTimeout(imgBusyT); imgBusyT = window.setTimeout(function () { imgBusy = false; }, 340);
          if (carouselApi) carouselApi.go(carouselApi.index() + dx);
        } else if (!horizontal && Math.abs(ay) >= 60) {
          locked = true; var dy = ay > 0 ? 1 : -1; ax = 0; ay = 0;
          navigateProduct(dy);
        }
      });
    }, { passive: false });
  }

  /* ---------- desktop magnifier (2x hover lens, DRIFT-parity) ---------- */
  function setupMagnifier() {
    if (!pdp) return;
    if ((pdp.getAttribute('data-sply-magnify') || '') !== 'true') return;
    var SIZE = 150, ZOOM = 2, BP = 1025;
    var lens = document.createElement('span');
    lens.className = 'sply-pdp__magnifier sply-surface sply-border';
    var limg = document.createElement('img');
    limg.className = 'sply-pdp__magnifier-img';
    limg.draggable = false;
    lens.appendChild(limg);
    document.body.appendChild(lens);
    var lastX = null, lastY = null;
    function hide() { lens.classList.remove('is-active'); pdp.classList.remove('sply-magnifying'); }
    function show(x, y) {
      if (window.innerWidth < BP) { hide(); return; }
      var vp = pdp.querySelector('[data-pdp-viewport]');
      if (!vp) { hide(); return; }
      var imgs = vp.querySelectorAll('.sply-pdp__slide img');
      var img = null, rect = null;
      for (var i = 0; i < imgs.length; i++) {
        var r = imgs[i].getBoundingClientRect();
        if (r.width && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) { img = imgs[i]; rect = r; break; }
      }
      if (!img) { hide(); return; }
      var hi = img.getAttribute('data-magnify-src') || img.currentSrc || img.src;
      if (limg.getAttribute('src') !== hi) limg.setAttribute('src', hi);
      var rx = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
      var ry = Math.max(0, Math.min(1, (y - rect.top) / rect.height));
      var zw = rect.width * ZOOM, zh = rect.height * ZOOM;
      limg.style.width = zw + 'px';
      limg.style.height = zh + 'px';
      limg.style.left = (-(rx * zw - SIZE / 2)) + 'px';
      limg.style.top = (-(ry * zh - SIZE / 2)) + 'px';
      lens.style.left = (x - SIZE / 2) + 'px';
      lens.style.top = (y - SIZE / 2) + 'px';
      lens.classList.add('is-active');
      pdp.classList.add('sply-magnifying');
    }
    function overImage(x, y) {
      var vp = pdp.querySelector('[data-pdp-viewport]');
      if (!vp || window.innerWidth < BP) return false;
      var imgs = vp.querySelectorAll('.sply-pdp__slide img');
      for (var i = 0; i < imgs.length; i++) {
        var r = imgs[i].getBoundingClientRect();
        if (r.width && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return true;
      }
      return false;
    }
    var DWELL = 2000, active = false, armTimer = null;
    function disarm() { active = false; if (armTimer) { window.clearTimeout(armTimer); armTimer = null; } hide(); }
    function arm() {
      if (armTimer) window.clearTimeout(armTimer);
      armTimer = window.setTimeout(function () {
        armTimer = null;
        if (lastX != null && overImage(lastX, lastY)) { active = true; show(lastX, lastY); }
      }, DWELL);
    }
    pdp.addEventListener('mouseleave', disarm);
    pdp.addEventListener('mousemove', function (e) {
      lastX = e.clientX; lastY = e.clientY;
      if (!overImage(lastX, lastY)) { disarm(); return; }
      if (active) { show(lastX, lastY); }
      else if (!armTimer) { arm(); }
    });
    // a swipe (image or product) hides the lens and re-starts the dwell timer
    magHide = function () { active = false; hide(); arm(); };
    magRefresh = function () { if (active && lastX != null && overImage(lastX, lastY)) show(lastX, lastY); };
  }

  window.addEventListener('popstate', function () { if (pdp) window.location.reload(); });

  /* ---------- product view: image carousel (x) + product nav (y) ---------- */
  function initCarousel(pdpEl) {
    var mode = pdpEl.getAttribute('data-transition') || 'slide';
    var track = pdpEl.querySelector('[data-pdp-track]');
    var viewport = pdpEl.querySelector('[data-pdp-viewport]');
    var slides = Array.prototype.slice.call(pdpEl.querySelectorAll('[data-index]'));
    var dots = Array.prototype.slice.call(pdpEl.querySelectorAll('[data-dot]'));
    var prev = pdpEl.querySelector('.sply-pdp__prev');
    var next = pdpEl.querySelector('.sply-pdp__next');
    var n = slides.length;
    var i = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint(animate) {
      for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle('is-active', k === i); }
      // the hero must be whatever image is actually on screen. pinned to slide 0 it stays parked
      // off-screen left in the track, so returning after a swipe morphs in from the wrong place.
      for (var h = 0; h < slides.length; h++) {
        var him = slides[h].querySelector('img');
        if (him) him.style.viewTransitionName = (h === i) ? 'sply-hero' : 'none';
      }
      if (mode === 'fade') {
        for (var s = 0; s < slides.length; s++) { slides[s].classList.toggle('is-active', s === i); }
        return;
      }
      if (track) {
        track.style.transition = (animate && !reduce) ? '' : 'none';
        track.style.transform = 'translate3d(-' + (i * 100) + '%,0,0)';
      }
    }
    function go(to) { if (n <= 1) return; magHide(); i = ((to % n) + n) % n; paint(true); window.setTimeout(magRefresh, 1180); }
    carouselApi = { go: go, index: function () { return i; } };

    if (n > 1) {
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });
    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    if (viewport) {
      var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, w = 1, locked = null;
      viewport.style.touchAction = 'none';
      viewport.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; startY = e.clientY; dx = 0; dy = 0; locked = null;
        w = viewport.clientWidth || 1;
        if (track) track.style.transition = 'none';
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX; dy = e.clientY - startY;
        if (locked === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (locked === 'x') {
          if (e.cancelable) e.preventDefault();
          if (n > 1 && track && !reduce) {
            track.style.transform = 'translate3d(calc(-' + (i * 100) + '% + ' + dx + 'px),0,0)';
          }
        } else if (locked === 'y') {
          if (e.cancelable) e.preventDefault();
        }
      });
      function end() {
        if (!dragging) return; dragging = false;
        if (locked === 'x') {
          if (n > 1 && Math.abs(dx) > w * 0.18) go(dx < 0 ? i + 1 : i - 1);
          else paint(true);
        } else if (locked === 'y') {
          var h = window.innerHeight || 600;
          if (Math.abs(dy) > Math.min(120, h * 0.12)) { navigateProduct(dy < 0 ? 1 : -1); }
          else { pdpEl.style.transition = 'transform .3s ease'; pdpEl.style.transform = 'translateY(0)'; }
        }
      }
      viewport.addEventListener('pointerup', end);
      viewport.addEventListener('pointercancel', end);
    }

    if (track) track.addEventListener('transitionend', function (ev) { if (ev.propertyName === 'transform') magRefresh(); });
    paint(false);
  }

  /* ---- liquid plus<->chevron morph (real path interpolation) ---- */
  var NAV_PLUS = [[12,5,12,19],[5,12,19,12]];
  var NAV_CHEV = [[15,6,9,12],[9,12,15,18]];
  function navSetD(svg, st) {
    var ps = svg.querySelectorAll('path'); if (ps.length < 2) return;
    ps[0].setAttribute('d', 'M' + st[0][0] + ' ' + st[0][1] + 'L' + st[0][2] + ' ' + st[0][3]);
    ps[1].setAttribute('d', 'M' + st[1][0] + ' ' + st[1][1] + 'L' + st[1][2] + ' ' + st[1][3]);
  }
  function navEase(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
  function navMorph(svg, from, to, dur) {
    if (reduceMo) { navSetD(svg, to); return; }
    var t0 = null;
    function fr(now) {
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / dur), e = navEase(t);
      var c = [[0,0,0,0],[0,0,0,0]];
      for (var i = 0; i < 2; i++) for (var j = 0; j < 4; j++) c[i][j] = from[i][j] + (to[i][j] - from[i][j]) * e;
      navSetD(svg, c);
      if (t < 1) window.requestAnimationFrame(fr);
    }
    window.requestAnimationFrame(fr);
  }
  function navVisibleIcon() {
    var ic = document.querySelectorAll('.sply-topbar__left [data-sply-navicon]');
    for (var i = 0; i < ic.length; i++) {
      var b = ic[i].closest('button');
      if (b && !b.hidden && b.offsetParent !== null) return ic[i];
    }
    return null;
  }
  // morph the currently-visible nav icon to a target shape (used by grid zoom + nav)
  function navMorphTo(state, dur) {
    var svg = navVisibleIcon(); if (!svg) return;
    var to = state === 'chevron' ? NAV_CHEV : NAV_PLUS;
    var from = state === 'chevron' ? NAV_PLUS : NAV_CHEV;
    navSetD(svg, from); navMorph(svg, from, to, dur || 470);
  }
  function navRun() {
    var svg = navVisibleIcon(); if (!svg) return;
    var onPdp = !!document.querySelector('[data-sply-pdp]');
    if (onPdp) { navSetD(svg, NAV_PLUS); navMorph(svg, NAV_PLUS, NAV_CHEV, 470); }
    else {
      var back = false; try { back = sessionStorage.getItem('sply-navback') === '1'; } catch (e) {}
      if (back) { try { sessionStorage.removeItem('sply-navback'); } catch (e) {} navSetD(svg, NAV_CHEV); navMorph(svg, NAV_CHEV, NAV_PLUS, 470); }
    }
  }
  if (document.prerendering) { document.addEventListener('prerenderingchange', navRun, { once: true }); }
  else { navRun(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) navRun(); });

})();
